<script lang="ts">
    import type {Writable} from 'svelte/store';
    import type {AuthorityTabsConfiguration, DocumentTabsConfiguration} from 'typings/portaro.be.types';
    import type {HeadlessTabsApiData} from 'shared/ui-widgets/tabset/types';
    import {getContext, onDestroy, tick} from 'svelte';
    import {TABS_CONTEXT_NAME} from 'shared/ui-widgets/tabset/types';

    export let config: AuthorityTabsConfiguration | DocumentTabsConfiguration;
    export let containsNoneTab = true;

    let tabSelected = false;
    let lastTabCount = 0;

    const api: Writable<any> = getContext(TABS_CONTEXT_NAME);
    if (!api) {
        throw new Error(
            '<KpTabGroupActiveTabSelector /> is missing a parent <TabGroup /> component.'
        );
    }

    const apiUnsubscribe = api.subscribe((apiData: HeadlessTabsApiData) => {
        if (apiData.tabs.length === 0) {
            return;
        }

        if (!tabSelected || apiData.tabs.length > lastTabCount) {
            highlightHighestPriorityTab(apiData);
        }
    });

    function highlightHighestPriorityTab(apiData: HeadlessTabsApiData) {
        const sortedTabs = Object.entries(config)
            .filter(([, tab]) => tab.showable)
            .sort(([, tabA], [, tabB]) => tabB.priority - tabA.priority);

        for (const [name,] of sortedTabs) {
            if (containsNoneTab && name === 'none' && findAndSelectTab(apiData, 'none')) {
                break;
            }

            if (findAndSelectTab(apiData, name)) {
                break;
            }
        }
    }

    function findAndSelectTab(apiData: HeadlessTabsApiData, name: string): boolean {
        const tabClass = `tab-${name}`;
        const tabElement = apiData.tabs.find((element) => element.classList.contains(tabClass));

        if (!tabElement) {
            return false;
        }

        const tabIndex = apiData.tabs.indexOf(tabElement);
        tabSelected = true;
        lastTabCount = apiData.tabs.length;

        tick().then(() => {
            apiData.setSelectedIndex(tabIndex);
        });
        return true;
    }

    onDestroy(() => {
        apiUnsubscribe();
    });
</script>
